import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import SliderDots from "../slider-dots";
import "./style.scss";

const ImageSlideshow = ({ slides, autoPlay, render }) => {
  const [activeSlide, setActiveSlide] = useState(0);

  const autoPlayRef = useRef();

  useEffect(() => {
    autoPlayRef.current = nextSlide;
  });

  useEffect(() => {
    const play = () => {
      autoPlayRef.current();
    };

    const interval = setInterval(play, autoPlay * 1000);

    return () => {
      clearInterval(interval);
    };
  }, [autoPlay]);

  const nextSlide = () => {
    if (activeSlide === slides.length - 1) {
      return setActiveSlide(0);
    }

    setActiveSlide(activeSlide + 1);
  };

  return (
    <div className="slideshow">
      {slides.map((slide, i) => {
        const isActive = i === activeSlide;
        return render({ slide, isActive });
      })}
      <div className="slideshow__dots">
        <SliderDots slides={slides} activeSlide={activeSlide} />
      </div>
    </div>
  );
};

ImageSlideshow.propTypes = {
  slides: PropTypes.array.isRequired,
  autoPlay: PropTypes.number,
};

ImageSlideshow.defaultProps = {
  autoPlay: 6,
};

export default ImageSlideshow;
